import { faCheckDouble, faCircleX, faEllipsisVertical } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DropdownMenu, IconButton } from '@nexelem/components';
import { openAutoAssigmentModal } from './AutoAssignmentModal';
import { useCustomTranslation } from '../../../../../hooks';
import { openAutoUnassigmentModal } from './AutoUnassignmentModal';

export const AutoAssignmentButton = () => {
  const { tWrapper } = useCustomTranslation('products.productionPlan.autoAssigment');
  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger>
        <IconButton Icon={<FontAwesomeIcon icon={faEllipsisVertical} />} />
      </DropdownMenu.Trigger>
      <DropdownMenu.Content>
        <DropdownMenu.Button StartIcon={<FontAwesomeIcon icon={faCheckDouble} />} onClick={openAutoAssigmentModal}>
          {tWrapper('assignMany')}
        </DropdownMenu.Button>
        <DropdownMenu.Button StartIcon={<FontAwesomeIcon icon={faCircleX} />} onClick={openAutoUnassigmentModal}>
          {tWrapper('unassignMany')}
        </DropdownMenu.Button>
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
};
